import script from "./OpenAreaSelectModel.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenAreaSelectModel.vue?vue&type=script&setup=true&lang=js"

import "./OpenAreaSelectModel.vue?vue&type=style&index=0&id=049d1ab0&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-049d1ab0"]])

export default __exports__